// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvestorProfileDto
 */
export interface IInvestorProfileDto {
    /**
     * 
     * @type {string}
     * @memberof IInvestorProfileDto
     */
    investment_objectives_type?: IInvestorProfileDtoInvestmentObjectivesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IInvestorProfileDto
     */
    investment_experience_type?: IInvestorProfileDtoInvestmentExperienceTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestorProfileDto
     */
    annual_income?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorProfileDto
     */
    networth_total?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorProfileDto
     */
    purpose_type?: IInvestorProfileDtoPurposeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IInvestorProfileDto
     */
    medical_expenses_cover_type?: IInvestorProfileDtoMedicalExpensesCoverTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IInvestorProfileDto
     */
    tolerance_model?: IInvestorProfileDtoToleranceModelEnum;
    /**
     * 
     * @type {string}
     * @memberof IInvestorProfileDto
     */
    risk_tolerance?: IInvestorProfileDtoRiskToleranceEnum;
    /**
     * 
     * @type {string}
     * @memberof IInvestorProfileDto
     */
    proposed_tolerance_model?: IInvestorProfileDtoProposedToleranceModelEnum;
}

/**
* @export
* @enum {string}
*/
export enum IInvestorProfileDtoInvestmentObjectivesTypeEnum {
    LONG_TERM = 'LONG_TERM',
    INFREQUENT = 'INFREQUENT',
    FREQUENT = 'FREQUENT',
    ACTIVE_DAILY = 'ACTIVE_DAILY',
    NEW = 'NEW'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorProfileDtoInvestmentExperienceTypeEnum {
    NONE = 'NONE',
    YRS_1_2 = 'YRS_1_2',
    YRS_3_5 = 'YRS_3_5',
    YRS_5_10 = 'YRS_5_10',
    YRS_10 = 'YRS_10_'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorProfileDtoPurposeTypeEnum {
    PAY_MEDICAL_EXPENSES = 'PAY_MEDICAL_EXPENSES',
    GROW_INVESTMENT_ASSETS = 'GROW_INVESTMENT_ASSETS'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorProfileDtoMedicalExpensesCoverTypeEnum {
    INVESTMENTS = 'INVESTMENTS',
    SAVINGS_LEVEL_1 = 'SAVINGS_LEVEL_1',
    SAVINGS_LEVEL_2 = 'SAVINGS_LEVEL_2',
    SAVINGS_LEVEL_3 = 'SAVINGS_LEVEL_3',
    SAVINGS_LEVEL_4 = 'SAVINGS_LEVEL_4'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorProfileDtoToleranceModelEnum {
    CONSERVATIVE = 'CONSERVATIVE',
    MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
    MODERATE = 'MODERATE',
    MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
    AGGRESSIVE = 'AGGRESSIVE'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorProfileDtoRiskToleranceEnum {
    LOW = 'LOW',
    MODERATE = 'MODERATE',
    SPECULATION = 'SPECULATION',
    HIGH = 'HIGH'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorProfileDtoProposedToleranceModelEnum {
    CONSERVATIVE = 'CONSERVATIVE',
    MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
    MODERATE = 'MODERATE',
    MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
    AGGRESSIVE = 'AGGRESSIVE'
}


/**
 * Check if a given object implements the IInvestorProfileDto interface.
 */
export function instanceOfIInvestorProfileDto(value: object): value is IInvestorProfileDto {
    return true;
}

export function IInvestorProfileDtoFromJSON(json: any): IInvestorProfileDto {
    return IInvestorProfileDtoFromJSONTyped(json, false);
}

export function IInvestorProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestorProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investment_objectives_type': json['investment_objectives_type'] == null ? undefined : json['investment_objectives_type'],
        'investment_experience_type': json['investment_experience_type'] == null ? undefined : json['investment_experience_type'],
        'annual_income': json['annual_income'] == null ? undefined : json['annual_income'],
        'networth_total': json['networth_total'] == null ? undefined : json['networth_total'],
        'purpose_type': json['purpose_type'] == null ? undefined : json['purpose_type'],
        'medical_expenses_cover_type': json['medical_expenses_cover_type'] == null ? undefined : json['medical_expenses_cover_type'],
        'tolerance_model': json['tolerance_model'] == null ? undefined : json['tolerance_model'],
        'risk_tolerance': json['risk_tolerance'] == null ? undefined : json['risk_tolerance'],
        'proposed_tolerance_model': json['proposed_tolerance_model'] == null ? undefined : json['proposed_tolerance_model'],
    };
}

export function IInvestorProfileDtoToJSON(json: any): IInvestorProfileDto {
    return IInvestorProfileDtoToJSONTyped(json, false);
}

export function IInvestorProfileDtoToJSONTyped(value?: IInvestorProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investment_objectives_type': value['investment_objectives_type'],
        'investment_experience_type': value['investment_experience_type'],
        'annual_income': value['annual_income'],
        'networth_total': value['networth_total'],
        'purpose_type': value['purpose_type'],
        'medical_expenses_cover_type': value['medical_expenses_cover_type'],
        'tolerance_model': value['tolerance_model'],
        'risk_tolerance': value['risk_tolerance'],
        'proposed_tolerance_model': value['proposed_tolerance_model'],
    };
}

